import gql from 'graphql-tag';

const getOfflineTimetablesQuery = gql`
query (
  $originPortName: String
  $destinationPortName: String
) {
  timetables (
    where: {
      route: {
        ports: { some: { name: { contains: $originPortName} } }
        and: { ports: { some: { name: { contains: $destinationPortName} } } }
      }
    }
  )
    {
    timetableType
    title
    route {
      name
    }
    releaseDetail
    pdfUrl
    imageUrl
  }
}
`;
const getAllOfflineTimetablesQuery = gql`
query {
  timetables
  {
    timetableType
    title
    route {
      name
      id
      originPort {
        name
      }
      destinationPort {
        name
      }
    }
    releaseDetail
    pdfUrl
    imageUrl
    key
    validFrom
    validUntil
    lastUpdated
  }
}
`;

export {
  getOfflineTimetablesQuery,
  getAllOfflineTimetablesQuery,
};
